<template>
  <v-card class="rsl-fixed-height">
    <v-container class="width-override">
      <!-- Overview -->
      <v-row v-if="showExpiryNotice">
        <v-col cols="12">
          <div class="license-expiry">{{ $t('GENERAL.LICENSE_NOTICE') }} {{ expiryDate }}</div>
        </v-col>
      </v-row>

      <v-row>
        <v-col sm="6" md="3" v-if="currentRole == 'adminRole'">
          <v-card @click="goTo('ProcessDesigner')" class="click-me">
            <v-card-title>
              Processes Deployed
            </v-card-title>
            <v-card-subtitle>
              Total number of deployed processes
            </v-card-subtitle>
            <v-card-text>
              <v-icon x-large color="#f87723">mdi-notebook-edit-outline</v-icon>
              <span class="dash-counters">{{ processCount }}</span>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col sm="6" md="3" v-if="currentRole == 'adminRole' || currentRole == 'supervisorRole'">
          <v-card @click="goTo('AllTasks')">
            <v-card-title>
              Active Cases
            </v-card-title>
            <v-card-subtitle>
              Total number of cases in flight
            </v-card-subtitle>
            <v-card-text>
              <v-icon x-large color="#f87723">mdi-fast-forward</v-icon>
              <span class="dash-counters">{{ allTasksCount }}</span>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col sm="6" md="3" v-if="currentRole == 'adminRole' || currentRole == 'supervisorRole' || currentRole == 'managerRole'">
          <v-card>
            <v-card-title>
              Total Follow Up
            </v-card-title>
            <v-card-subtitle>
              Total cases requiring follow up
            </v-card-subtitle>
            <v-card-text>
              <v-icon x-large color="warning">mdi-clock-time-four-outline</v-icon>
              <span class="dash-counters">{{ allTasksFollowUp }}</span>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col sm="6" md="3" v-if="currentRole == 'adminRole' || currentRole == 'supervisorRole' || currentRole == 'managerRole'">
          <v-card>
            <v-card-title>
              Total Overdue
            </v-card-title>
            <v-card-subtitle>
              Total cases now overdue
            </v-card-subtitle>
            <v-card-text>
              <v-icon x-large color="error">mdi-clock-alert-outline</v-icon>
              <span class="dash-counters">{{ allTasksOverdue }}</span>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      
      <!-- Tasks -->
      <v-row>
        <v-col sm="6" md="3" v-if="currentRole == 'adminRole' || currentRole == 'supervisorRole' || currentRole == 'managerRole'">
          <v-card @click="goTo('TeamTasks')">
            <v-card-title>
              Team Tasks
            </v-card-title>
            <v-card-subtitle>
              Tasks assigned to your team
            </v-card-subtitle>
            <v-card-text>
              <v-icon x-large color="#f87723">mdi-account-group</v-icon>
              <span class="dash-counters">{{ teamTasksCount }}</span>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col sm="6" md="3">
          <v-card @click="goTo('MyTasks')">
            <v-card-title>
              My Tasks
            </v-card-title>
            <v-card-subtitle>
              Tasks assigned to you
            </v-card-subtitle>
            <v-card-text>
              <v-icon x-large color="#f87723">mdi-inbox-multiple</v-icon>
              <span class="dash-counters">{{ myTasksCount }}</span>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col sm="6" md="3">
          <v-card>
            <v-card-title>
              Follow Up
            </v-card-title>
            <v-card-subtitle>
              Cases you need to follow up
            </v-card-subtitle>
            <v-card-text>
              <v-icon x-large color="warning">mdi-clock-time-four-outline</v-icon>
              <span class="dash-counters">{{ myTasksFollowUp }}</span>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col sm="6" md="3">
          <v-card>
            <v-card-title>
              Overdue
            </v-card-title>
            <v-card-subtitle>
              Your cases now overdue
            </v-card-subtitle>
            <v-card-text>
              <v-icon x-large color="error">mdi-clock-alert-outline</v-icon>
              <span class="dash-counters">{{ myTasksOverdue }}</span>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-card>
</template>

<script>
  import { mapGetters } from 'vuex';
  export default {
    name: 'dashboard',
    computed: {
      ...mapGetters(['usersGroups', 'teamMembers', 'allTasksCount', 'allTasksFollowUp', 'allTasksOverdue', 'myTasksCount', 'myTasksFollowUp', 'myTasksOverdue', 'teamTasksCount', 'processCount', 'unassignedTasksCount', 'licenseExpiryDate'])
    },
    data: function() {
      return {
        currentRole: this.$store.state.currentRole,
        showExpiryNotice: false,
        expiryDate: ''
      }
    },
    created() {
      this.$store.dispatch('getAllTasks');
      this.$store.dispatch('getMyTasks');
      this.$store.dispatch('getAllProcesses');
      this.refreshTeamTasks();
      this.checkLicense();
    },
    methods: {
      checkLicense() {
        let eDate = new Date(this.licenseExpiryDate);
        let today = new Date();

        let diff = Math.abs(today.getTime() - eDate.getTime());
        let daysLeft = diff / (1000 * 60 * 60 * 24);
        
        if(daysLeft <= 30) {
          this.showExpiryNotice = true;
          this.expiryDate = eDate;
        }
      },
      refreshTeamTasks() {
        this.$store.dispatch('getUsersGroups').then( () => {
          this.$store.dispatch('getTeamMembers').then( () => {
            let groups = '';
            for(let i = 0; i < this.usersGroups.length; i++) {
              groups = groups + this.usersGroups[i].id + ','
            }
            groups = groups.replace(/,\s*$/, "");

            let members = '';
            for(let j = 0; j < this.teamMembers.length; j++) {
              if(this.teamMembers[j].id !== this.$store.state.currentUser) {
                members = members + this.teamMembers[j].id + ','
              }
            }
            members = members.replace(/,\s*$/, "");

            let payload = {
              'groups': groups,
              'members': members
            }

            this.$store.dispatch('getTeamTasks', payload);
          });
        });
      },
      goTo(page) {
        this.$router.push({ name: page });
      }
    }
  }
</script>

<style>
  .dash-counters {
    font-size: 35px;
    padding-top: 10px;
    float: right;
  }
  .click-me {
    cursor: pointer;
  }
  .license-expiry {
    background-color: red;
    border: 1px solid red;
    border-radius: 5px;
    color: white;
    text-align: center;
    padding: 5px 0;
  }
</style>